/**
 * Created by Ning Jiang on 2021-06-22.
 */

import {BitmapCountUp} from "@nolimitcity/slot-game/bin/component/BitmapCountUp";
import {gsap} from "gsap";
import {RockBottomGameAssets} from "../../../RockBottomGameAssets";
import {Layers, RockBottomLayers} from "../../../view/RockBottomLayers";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";

export class BigWinCountUp extends PIXI.Container {

    protected _countUp: BitmapCountUp;
    private _endingScale: number = 0.7;

    constructor() {
        super();

        const style = {
            fontName: RockBottomGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 40,
            letterSpacing: -15
        };
        this._countUp = new BitmapCountUp(style);
        this._countUp.shrinkSize = true;
        this._countUp.visible = false;
        this._countUp.y = -50;
        this.addChild(this._countUp);
        this.position.set(360, 460);
        this._waysCount = new PIXI.Text("", new PIXI.TextStyle({
            fill: 0xffffff,
            fontFamily: OpenSans.FAMILY,
            wordWrap: false,
            fontWeight: FontWeight.BOLD,
            fontSize: 31,
            stroke: 0x000000,
            strokeThickness: 10,
            lineJoin: "round"
        }));
        this._waysCount.anchor.set(0.5, 0.5);
        this._waysCount.position.set(0, 50);
        this._waysCount.visible = false;
        this.addChild(this._waysCount);
        RockBottomLayers.getLayer(Layers.WIN_COUNT_UP)?.addChild(this);
    }

    private _waysCount: PIXI.Text;

    private set waysCount(value: number) {
        this._waysCount.text = value.toString() + (value > 1 ? ' Ways Won' : ' Way Won');
    }

    public showWays(ways: number): void {
        this.waysCount = ways;
        this._waysCount.visible = true;
        this._waysCount.alpha = 1;
    }

    public getCountUpAnimation(from: number, to: number, duration: number): TimelineLite {
        const tl = gsap.timeline();
        tl.add([
            () => {
                this._countUp.maxTextWidth = 660;
                this._countUp.scale.set(1);
                this._countUp.alpha = 1;
                this._countUp.visible = true;
            },
            this._countUp.getCountUpAnimation(from, to, duration, `power3.out`)
        ]);

        return tl;
    }

    public stay(): TimelineLite {
        const tl = gsap.timeline();
        tl.add([
            gsap.to(this._countUp.scale, {
                duration: 0.5,
                x: this._endingScale,
                y: this._endingScale,
                ease: `elastic.out(1, 1)`
            }),
        ]);
        // timeline.add(() => ElPasoGunfightSoundConfig.soundPlayer.playTrack({name : ElPasoGunfightSoundConfig.instance.COUNT_UP_END_FALL_BACK}), "-=0.3");
        return tl;
    }

    public remove(): TimelineLite {
        const tl = gsap.timeline();
        if (this._countUp.visible) {
            tl.add([gsap.to(this._countUp, {duration: 0.5, alpha: 0, y: -150, ease: `power2.in`}),
                gsap.to(this._waysCount, {duration: 0.5, alpha: 0, y: -50, ease: `power2.in`})], `+=0.4`); // stay a short while after count up.
            tl.add(() => {
                this._countUp.y = -50;
                this._countUp.scale.set(1);
                this._countUp.visible = false;
                this._waysCount.text = "";
                this._waysCount.visible = false;
                this._waysCount.position.y = 50;
            });
        }

        return tl;
    }
}